'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = require('./passive-event-listeners');

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll/modules/mixins/cancel-events.js
// module id = 2076
// module chunks = 0